import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import { Link } from 'react-router-dom';
import { PrimaryButton } from 'appSrc/components/UI';
import NewAdvertiserModal from '../../Modals/Advertiser/NewAdvertiserModal';
import MissingFromDBTable from './MissingFromDBTable';
import MissingFromAPITable from './MissingFromAPITable';
import MissingDomainsTable from './MissingDomainsTable';
import MismatchedDomainsTable from './MismatchedDomainsTable';
import FieldDiffsTable from './FieldDiffsTable';
import style from './styles/style.module.css';

class AdvertiserManagementView extends Component {
    constructor( props ) {
        super( props );

        this.state = {
            fetching: true,
            updatingFieldDiffs: false,
            comparisonData: [],
            affiliates: [],
            advertiserNameDifferences: [],
            domainDifferences: [],
            displayData: 'missingFromDB',
            advertiserInNewModal: null,
            affiliateInNewModal: null,
            recordIndexInNewModal: null,
        };
        this.loadAffiliates();
    }
    loadAffiliates = () => {
        return Promise.all([
            this.props.compareAdvertiserData(),
            this.props.getAllAffiliates(),
        ])
        .then( ( data ) => {
            this.setState( {
                fetching: false,
                comparisonData: data[0],
                advertiserNameDifferences: data[0].dataDifferences.filter( difference => difference.differentFields.indexOf('advertiserName') !== -1 ),
                domainDifferences: data[0].dataDifferences.filter( difference => difference.differentFields.indexOf('domains') !== -1 ),
                affiliates: data[1].rows,
            } );
            return data;
        } );
    }
    showDataHandler = ( dataName ) => {
        return () => {
            this.setState( {
                displayData: dataName,
            } );
        };
    }
    getAffiliateFromType = ( affiliateType ) => {
        const { affiliates } = this.state;
        let affiliateRecord = null;
        for ( let i = 0; i < affiliates.length; i++ ) {
            if ( affiliates[i].affiliateType === affiliateType ) {
                affiliateRecord = affiliates[i];
                break;
            }
        }
        return affiliateRecord;
    }
    openNewModal = ( data, dataIndex ) => {
        const affiliateRecord = this.getAffiliateFromType( data.affiliate );
        if ( affiliateRecord === null ) {
            console.error( 'Could not match affiliate type to a valid record.' );
            return;
        }
        this.setState( {
            advertiserInNewModal: data,
            affiliateInNewModal: affiliateRecord,
            recordIndexInNewModal: dataIndex,
        } );
    }
    onNewSubmit = () => {
        this.setState( ( altState ) => {
            if ( altState.comparisonData && altState.comparisonData.recordsMissingFromDB && altState.recordIndexInNewModal !== null ) {
                altState.comparisonData.recordsMissingFromDB.splice( altState.recordIndexInNewModal, 1 );
            }
            altState.comparisonData.recordsMissingFromDB = altState.comparisonData.recordsMissingFromDB.slice( 0 );

            altState.advertiserInNewModal = null;
            altState.affiliateInNewModal = null;
            altState.recordIndexInNewModal = null;
            return altState;
        } );
    }
    onNewClose = () => {
        this.setState( {
            advertiserInNewModal: null,
            affiliateInNewModal: null,
            recordIndexInNewModal: null,
        } );
    }
    confirmUpdateFieldDiffs = () => {
        // only update advertiser name differences
        if ( this.state.advertiserNameDifferences.length === 0 ) {
            return window.alert( 'No differences found. Nothing to update.' );
        }

        if ( window.confirm( 'Are you sure you want to update fields in the database to match the API?' ) ) {
            this.setState( {
                updatingFieldDiffs: true,
            }, () => {
                this.updateFieldDiffsInDB();
            } );
        }
    }
    updateFieldDiffsInDB = () => {
        // only update advertiser name differences
        Promise.all( this.state.advertiserNameDifferences.map( ( difference ) => {
            return this.props.updateAdvertiser( difference.db.dbAdvertiserId, {
                advertiser_name: difference.api.advertiserName,
            } );
        } ) )
        .then( () => {
            this.setState( {
                fetching: true,
                updatingFieldDiffs: false,
            }, () => {
                this.loadAffiliates();
            } );
        } );
    }
    removeMissingDomainFromUI = ( updatedRecordIndex ) => {
        this.setState( ( altState ) => {
            altState.comparisonData.dbRecordsLackingDomains.splice( updatedRecordIndex, 1 );
            altState.comparisonData = { ...altState.comparisonData };
            altState.comparisonData.dbRecordsLackingDomains = altState.comparisonData.dbRecordsLackingDomains.slice( 0 );
            return altState;
        } );
    }
    updateMissingDomainFromUI = ( updatedRecordIndex, updatedAdvertiser ) => {
        this.setState( ( altState ) => {
            altState.comparisonData.dbRecordsLackingDomains.splice( updatedRecordIndex, 1, {
                ...altState.comparisonData.dbRecordsLackingDomains[updatedRecordIndex],
                advertiserName: updatedAdvertiser.advertiser_name,
            } );
            altState.comparisonData = { ...altState.comparisonData };
            altState.comparisonData.dbRecordsLackingDomains = altState.comparisonData.dbRecordsLackingDomains.slice( 0 );
            return altState;
        } );
    }
    removeMismatchedDomainFromUI = ( updatedRecordIndex ) => {
        this.setState( ( altState ) => {
            altState.domainDifferences.splice( updatedRecordIndex, 1 );
            altState.domainDifferences = altState.domainDifferences.slice( 0 );
            return altState;
        } );
    }
    updateMismatchedDomainFromUI = ( updatedRecordIndex, updatedAdvertiser ) => {
        this.setState( ( altState ) => {
            let newDifferences = { ...altState.domainDifferences[updatedRecordIndex] };
            newDifferences.db.advertiserName = updatedAdvertiser.advertiser_name;
            newDifferences.db.domains = updatedAdvertiser.advertisers_domains.map( domain => domain.domain );

            altState.domainDifferences.splice( updatedRecordIndex, 1, newDifferences );
            altState.domainDifferences = altState.domainDifferences.slice( 0 );
            return altState;
        } );
    }

    render() {
        const { fetching, updatingFieldDiffs, comparisonData, advertiserNameDifferences, domainDifferences, displayData } = this.state;

        return (
            <section className={ style.page }>
                <div className={ style.head }>
                    <h2>Affiliates and Advertisers</h2>
                    <div className={ style.controls }>
                        <PrimaryButton label='Missing From Database' onClick={ this.showDataHandler( 'missingFromDB' ) } reverse={ displayData !== 'missingFromDB' } />
                        <PrimaryButton label='Missing From Affiliate API' onClick={ this.showDataHandler( 'missingFromAPI' ) } reverse={ displayData !== 'missingFromAPI' }
                        style={ { marginLeft: '15px' } } />
                        <PrimaryButton label='Field Differences' onClick={ this.showDataHandler( 'fieldDifferences' ) } reverse={ displayData !== 'fieldDifferences' }
                        style={ { marginLeft: '15px' } } />
                        <PrimaryButton label='Missing Domains' onClick={ this.showDataHandler( 'missingDomains' ) } reverse={ displayData !== 'missingDomains' }
                        style={ { marginLeft: '15px' } } />
                        <PrimaryButton label='Mismatched Domains' onClick={ this.showDataHandler( 'mismatchedDomains' ) } reverse={ displayData !== 'mismatchedDomains' }
                        style={ { marginLeft: '15px' } } />
                    </div>
                    <div className={ style.tabs }>
                        <Link to='/admin/affiliates' className={ style.tabOption }
                        data-active={ false }>View All</Link>
                        <Link to='/admin/affiliates/manage' className={ style.tabOption }
                        data-active={ true }>Manage</Link>
                    </div>
                </div>
                <div className={ style.body }>
                    <section className={ style.manageAdvertisers }>
                        <div className={ style.filters }>
                        </div>
                        { fetching ?
                            <div>
                                <LoadingReplace />
                                <h3>Performing advertiser data analysis. This may take several seconds...</h3>
                            </div>
                            :
                            <div>
                                { displayData === 'missingFromDB' && (
                                    <MissingFromDBTable recordsMissingFromDB={ comparisonData.recordsMissingFromDB }
                                    openNewModal={ this.openNewModal } />
                                ) }
                                { displayData === 'missingFromAPI' && (
                                    <MissingFromAPITable recordsMissingFromAPI={ comparisonData.recordsMissingFromAPI } />
                                ) }
                                { displayData === 'fieldDifferences' && (
                                    <FieldDiffsTable dataDifferences={ advertiserNameDifferences }
                                    updatingFieldDiffs={ updatingFieldDiffs }
                                    confirmUpdateFieldDiffs={ this.confirmUpdateFieldDiffs } />
                                ) }
                                { displayData === 'missingDomains' && (
                                    <MissingDomainsTable dbRecordsLackingDomains={ comparisonData.dbRecordsLackingDomains }
                                    removeRecordFromUI={ this.removeMissingDomainFromUI }
                                    updateRecordFromUI={ this.updateMissingDomainFromUI } />
                                ) }
                                { displayData === 'mismatchedDomains' && (
                                    <MismatchedDomainsTable domainDifferences={ domainDifferences }
                                    removeRecordFromUI={ this.removeMismatchedDomainFromUI }
                                    updateRecordFromUI={ this.updateMismatchedDomainFromUI } />
                                ) }
                                { this.state.advertiserInNewModal &&
                                    <NewAdvertiserModal closeModal={ this.onNewClose }
                                    onSubmit={ this.onNewSubmit }
                                    advertiser={ this.state.advertiserInNewModal }
                                    affiliate={ this.state.affiliateInNewModal } />
                                }
                            </div>
                        }
                    </section>
                </div>
            </section>
        );
    }
}

const mapDispatchToProps = () => {
    return {
        getAllAffiliates: () => {
            return dAPI.get( '/affiliates' );
        },
        compareAdvertiserData: ( queryObject ) => {
            return dAPI.get( '/affiliates/compareAdvertiserData', queryObject );
        },
        updateAdvertiser: ( id, data ) => {
            return dAPI.patch( `/affiliates/dbadvertisers/${ id }`, data );
        },
    };
};

export default connect( null, mapDispatchToProps )( AdvertiserManagementView );
